import type { ReactNode } from "react";
import { createRoot } from "react-dom/client";

/** Mounts a page into #root once the document is ready. */
export function mount(node: ReactNode) {
  const start = () => {
    const el = document.getElementById("root");
    if (!el) throw new Error("#root not found");
    createRoot(el).render(node);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
}
